import React from 'react';
import './Input.css';
/**
 * Renders the Label with Input component.
 *
 * @param {string} id - the ID's of input element
 * @param {string} [label] - the label text
 * @param {string} [className] - the CSS classes prefix -label and -input
 * @param {string} [labelStyles] - the CSS classes for label
 * @param {string} [inputStyles] - the CSS classes for input
 * @param {e => handleChange(e.target.value)} onChange - onChange handler
 * @param {string} [placeholder] - the placeholder text for input element
 * @param {string} value - value for input
 * @param {string} typeInput - the HTML input type
 *
 * @example
 * <Input
 *  id='username'
 *  className='a6y-react-auth'
 *  onChange={e => handleChange(e.target.value)}
 *  placeholder='user'
 *  label='username'
 *  value={value}
 *  typeInput='text'
 * />
 */
var Input = function (_a) {
    var _b, _c;
    var _d, _e;
    var id = _a.id, _f = _a.label, label = _f === void 0 ? '' : _f, labelStyles = _a.labelStyles, inputStyles = _a.inputStyles, _g = _a.className, className = _g === void 0 ? 'a6y-react-auth' : _g, onChange = _a.onChange, _h = _a.placeholder, placeholder = _h === void 0 ? id : _h, value = _a.value, typeInput = _a.typeInput;
    var classNames = require('classnames');
    var LabelClass = classNames((_b = {},
        _b[className + "__label--" + id] = id ? true : false,
        _b));
    var InputClass = classNames((_c = {},
        _c[className + "__label__input--" + id] = id ? true : false,
        _c));
    return (React.createElement("label", { htmlFor: id, className: labelStyles && labelStyles.length > 0
            ? labelStyles + " "
            : className + "__label " + LabelClass },
        label &&
            ((_e = (_d = globalThis.A6YReactAuthConfig.components) === null || _d === void 0 ? void 0 : _d.Inputs) === null || _e === void 0 ? void 0 : _e.labels) &&
            label,
        React.createElement("input", { id: id, name: id, type: typeInput, onChange: onChange, className: inputStyles && inputStyles.length > 0
                ? inputStyles + " "
                : className + "__label__input " + InputClass, placeholder: placeholder, value: value ? value : '' })));
};
export default Input;
//# sourceMappingURL=Input.js.map